import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfInteractionsGoalService } from '../../../core/application/services/goals/get-self-interactions-goal.service';
import { SelfInteractionsGoalEntity } from '../../../core/domain/entities/goals/app-goals/self-interactions-goal.entity';
import { GetSelfGoalSummaryRequestDto } from '../../dtos/goals/get-self-goal-summaries.request.dto';

export class GetSelfInteractionsGoalQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfInteractionsGoalService
  ) {}
  async execute(
    props: GetSelfGoalSummaryRequestDto
  ): Promise<SelfInteractionsGoalEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
